import React, { useEffect } from 'react';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SystemSection } from './components/SystemSection';
import { LookInside } from './components/LookInside';
import { Bonuses } from './components/Bonuses';
import { NotEbook } from './components/NotEbook';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PIXEL_ID } from './data/constants';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
type PixelWindow = Window & typeof globalThis & {
  fbq?: PixelFunction;
  _fbq?: PixelFunction;
};
interface AppProps {
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="3rcj7c4kla37o">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="3rbzomln47asl" />
      </noscript>
      <div className="min-h-screen w-full overflow-x-hidden bg-white" data-id="element-2" data-mp="2zmeo498kfm81">
        {showPurchasePopup && <PurchasePopup data-id="element-3" data-mp="33nq921ghvj9w" />}
        <main data-id="element-4" data-mp="33myl9ct52pu6">
          <Hero data-id="element-5" data-mp="33oi2p6qj76xj" />
          <PainSection data-id="element-6" data-mp="38m1gy6n8bjph" />
          <SystemSection data-id="element-7" data-mp="38li6fazwrxlh" />
          <LookInside data-id="element-8" data-mp="38k6w0sbyjrle" />
          <Bonuses data-id="element-9" data-mp="38o4fxg6d0n6c" />
          <NotEbook data-id="element-10" data-mp="3dkl4ucldv5kh" />
          <Offer data-id="element-11" data-mp="3dl4kfmnk9hvc" />
          <Guarantee data-id="element-12" data-mp="3dlnsmbnesrw6" />
          <Testimonials data-id="element-13" data-mp="3dirv2ofh4589" />
          <FAQ data-id="element-14" data-mp="nvj3xh1mugq9" />
          <FinalCTA data-id="element-15" data-mp="nw2cw89b1us5" />
        </main>
        <Footer data-id="element-16" data-mp="nv0ybtt2yq5o" />
      </div>
    </>;
}
function initMetaPixel() {
  const pixelWindow = window as PixelWindow;
  try {
    if (!pixelWindow.fbq) {
      const fbq = ((...args: unknown[]) => {
        if (fbq.callMethod) {
          fbq.callMethod(...args);
        } else {
          fbq.queue?.push(args);
        }
      }) as PixelFunction;
      pixelWindow.fbq = fbq;
      if (!pixelWindow._fbq) pixelWindow._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript?.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
    }
    pixelWindow.fbq?.('init', PIXEL_ID);
    pixelWindow.fbq?.('track', 'PageView');
  } catch (error) {
    console.warn('Meta Pixel init skipped:', error);
  }
}